export default __webpack_public_path__ + "assets/img/refer_a_friend_deu_may_campaign_2025.svg";